































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DepositEvent, Boat } from '@/api/product';
import { Getter, Action } from 'vuex-class';
import { CreateStripeDepositSessionRequest } from '@/api/stripe';
import moment from 'moment-timezone';
import { Config } from '@/api/config';

interface StripeObj {
  redirectToCheckout(opts: {sessionId: string}): void;
}

declare var Stripe: (key: string, opts: object) => StripeObj;

@Component({
  filters: {
    formatTime(t: string): string {
      const m = moment(t, 'H:mm');
      return m.minute() > 0 ? m.format('h:m A') : m.format('h A');
    }
  }
})
export default class MakeDeposit extends Vue {
  @Prop(Object) public readonly event!: DepositEvent;
  @Action('cart/createStripeDepositSession') public readonly createSession!: 
    (req: CreateStripeDepositSessionRequest) => Promise<{id: string}>; 
  @Getter('product/boatByID') public getBoat!: (id: number) => Boat;
  @Action('loadConfig') public loadConfig!: () => Promise<void>;
  @Getter('config') public readonly config!: Config;

  public publishableKey = process.env.VUE_APP_STRIPE_PUBLISH_KEY || '';
  public stripeAccount = process.env.VUE_APP_STRIPE_ACCT || '';
  public stripe: StripeObj | null = null;
  public terms = false;

  public async mounted() {
    this.loadConfig();
    await this.$loadScript('https://js.stripe.com/v3/');
    this.createButton();
    // this.estimated = this.event.minimum;       
  }

  public createButton() {
    if (this.stripeAccount) {
      this.stripe = Stripe(this.publishableKey, {stripeAccount: this.stripeAccount});
    } else {
      this.stripe = Stripe(this.publishableKey, {});
    }
  }

  public get date(): moment.Moment { return moment(this.event.start, 'YYYY-MM-DD H:mm').startOf('day'); }
  public get tripTypes(): string[] { return ["Event", "Fishing"]; }
  public get maxPpl(): {[key: string]: number} { return {"Event": 110, "Fishing": 100}; }
  public get tripLengths(): number[] { return [3, 4, 5, 6]; }

  public selectedTime = '';
  public tripType = '';
  public tripLength = 3;
  public checkoutDlg = false;
  public estimated = '1';

  @Watch('tripType')
  public onChangeType(newVal: string, oldVal: string) {
    if (Number(this.estimated) > this.maxPpl[newVal]) {
      this.estimated = String(this.maxPpl[newVal]);
    }
  }

  @Watch('selectedTime')
  public onChangeTime(newVal: string, oldVal: string) {
    if (!this.validLength(this.tripLength+0.5)) {
      this.tripLength = 3;
    }
  }

  public validLength(t: number): boolean {
    if (!this.event.firstOfDay) {
      return true;
    }

    let m = moment(this.selectedTime, 'H:mm');
    if (m.isAfter(this.event.firstOfDay)) { return true; }
    m.add(t, 'h');
    return m.isBefore(this.event.firstOfDay);
  }

  public validTime(t: string): boolean {
    if (!this.event.firstOfDay) {
      return true;
    }
    let m = moment(t, 'H:mm');
    return !m.isBetween(this.event.firstOfDay.clone().subtract(3.5, 'h'), this.event.firstOfDay, undefined, '()')
  }

  public close() {
    this.$emit('input', false);
  }

  public async doCheckout() {
    if (!this.stripe) { return; }
    
    const sess = await this.createSession({
      date: this.date.format('YYYY-MM-DD'),
      time: this.selectedTime,
      priceId: this.event.price.id,
      tripLength: this.tripLength,
      tripType: this.tripType,
      estimated: Number(this.estimated),
    });
    this.stripe.redirectToCheckout({sessionId: sess.id});
  }
}
